export { default } from "ember-router-helpers/helpers/replace-with.js";
